import type { TOC } from '@ember/component/template-only';
import { and, notEq } from 'ember-truth-helpers';
import PlatformJobAttachments from 'garaje/components/platform-job-attachments';
import PlatformJobFailure from 'garaje/components/platform-job-failure';
import type PlatformJob from 'garaje/models/platform-job';

interface PlatformJobReportsSignature {
  Args: {
    categorizedPlatformJobs: Record<string, PlatformJob[]>;
  };
  Element: HTMLDivElement;
}

function getPluginCategoryName(platformJobs: PlatformJob[]): string | undefined {
  return platformJobs[0]?.pluginCategoryName;
}

<template>
  <div ...attributes>
    {{#each-in @categorizedPlatformJobs as |category platformJobs|}}
      {{#if (and (notEq category "nda") (notEq category "host-notifications"))}}
        <div data-test-plugin-activity-category={{category}} class="border-b pb-2 mb-4">
          <h4 class="text-sm">{{getPluginCategoryName platformJobs}}</h4>
          <ul class="list-none p-0 m-0 leading-normal mt-2">
            {{#each platformJobs as |platformJob|}}
              <li class="mb-1 text-sm text-carbon-70" data-test-plugin-activity-job={{platformJob.pluginName}}>
                {{#if platformJob.queued}}
                  <img
                    src="/assets/images/orange-progress-small.svg"
                    class="sendingNow mr-2"
                    alt=""
                    role="presentation"
                  />
                  {{platformJob.pluginName}}: queued
                {{else if platformJob.inProgress}}
                  <img
                    src="/assets/images/orange-progress-small.svg"
                    class="sendingNow mr-2"
                    alt=""
                    role="presentation"
                  />
                  {{platformJob.pluginName}}: in progress&hellip;
                {{else if platformJob.ignored}}
                  <img src="/assets/images/gray-dash-small.svg" style="margin-right: 10px" alt="" role="presentation" />
                  {{platformJob.pluginName}}: ignored
                {{else if platformJob.done}}
                  <img src="/assets/images/checkmark-small-gray.svg" class="mr-2" alt="" role="presentation" />
                  {{platformJob.pluginName}}: completed
                {{else if platformJob.failed}}
                  <div>
                    <img src="/assets/images/cross-small-red.svg" class="mr-2" alt="" role="presentation" />
                    {{platformJob.pluginName}}: failed
                  </div>
                  <PlatformJobFailure @platformJob={{platformJob}} />
                {{else}}
                  <img src="/assets/images/gray-dash-small.svg" style="margin-right: 10px" alt="" role="presentation" />
                  {{platformJob.pluginName}}: unknown
                {{/if}}
                <PlatformJobAttachments @attachments={{platformJob.attachments}} />
              </li>
            {{/each}}
          </ul>
        </div>
      {{/if}}
    {{/each-in}}
  </div>
</template> satisfies TOC<PlatformJobReportsSignature>;
